module.exports = __webpack_public_path__ + "img/icon-no-fees.33d594b.svg";